import Choices from 'choices.js';

const wrapTrailingTE = (label) =>
    label.endsWith('TE') ? `${label.slice(0, -2)}<sub>TE</sub>` : label;

export const choicesJS = () => {
    // Initialize all select elements with the class 'choices-select'
    const selectElements = document.querySelectorAll('select');
    
    selectElements.forEach(select => {

        if (
            !select.classList.contains('notice-country') &&
            !select.classList.contains('notice-investor-type')
        ) {

            select.querySelectorAll('option').forEach((option) => {
                const label = option.textContent.trim();
                if (label.endsWith('TE')) {
                    option.textContent = wrapTrailingTE(label);
                }
            });

            new Choices(select, {
                allowHTML: true,
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: false,
                position: 'bottom'
            });

        }
        
    });
}; 